import React, { useEffect } from 'react'

const FontLoader = () => {
	useEffect(() => {
		const WebFont = require('webfontloader')
		WebFont.load({
			google: { 
				families: [
					'Work+Sans:400,700', 'proxima nova', 'sans-serif', 'Righteous'
				] 
			}
		})
	}, [])
	return <div />
}

export default FontLoader